import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {ServicePath} from "./service.path";
import {Constant} from '../common/constant';

@Injectable({
  providedIn: 'root'
})
export class ServiceApi {

  reformatQuery(queries: any[], useAndMark = false): string {
    let filledValues = queries.filter((query: any) => {
      return query.value && query.value !== undefined && query.value !== null;
    });
    let concatQueries = filledValues.map((query: any) => {
      return query.key + '=' + query.value;
    });
    if (concatQueries.length > 0) {
      return (useAndMark ? '&' : '?') + concatQueries.join('&');
    }
    return '';
  }

  constructor(private http: HttpClient) {
  }

  public searchPricing(type?: any, day?: string): Observable<any> {
    return this.http.get(Constant.getHttpsBaazarHost() + ServicePath.PRICING_SEARCH + '/' + type + '/' + day);
  }

  public getRangeSuggestBenefits(): Observable<any> {
    return this.http.get(Constant.getHttpsBaazarHost() + ServicePath.RANGE_SUGGESTED_BENEFITS);
  }

  public getBenefitHistory(price?: any, time?: any): Observable<any> {
    return this.http.get(Constant.getHttpsBaazarHost() + ServicePath.BENEFITS_HISTORY + this.reformatQuery([{
      key: 'price',
      value: price
    }, {
      key: 'time',
      value: time
    }]), {});
  }

  public getPriceHistory(time?: any): Observable<any> {
    return this.http.get(Constant.getHttpsBaazarHost() + ServicePath.PRICE_HISTORY + '/' + time);
  }

}
